export const DOLLARS = "USD";
export const DOLLARS_PLUS_POINTS = "USD_PLUS_POINTS";
export const POINTS = "POINTS";
